<template>
    <v-dialog max-width="500px" v-model="show">
        <DlgMessage ref="dlgMsg"></DlgMessage>
        <v-card>
            <v-toolbar flat dark color="panel1">
                <v-toolbar-title>Change PIN</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="visible= false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <div class="pa-5">
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-form ref="mainForm">
                            <v-text-field 
                            v-if="show" autofocus
                            label="New PIN" 
                            outlined 
                            :rules="[rules.required, rules.counter, rules.digit]"
                            counter
                            maxlength="6"
                            v-model="form.pin"
                            clearable
                        ></v-text-field>
                        </v-form>
                    </v-col>
                </v-row>
            </div>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="cbtnSave" dark @click="save">
                    <v-icon left dark>mdi-content-save</v-icon>
                    Save
                </v-btn>
                <v-btn class="ml-2" color="cbtnRed" dark @click="visible = false">
                    <v-icon left dark>mdi-close</v-icon>
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>


<script>
import DlgMessage from '@/components/DlgMessage'
import ApCustomerService from '@/services/ApCustomerService'
export default {
    name: "DlgCustChangePIN",
    props: {
        visible:Boolean,
    },      
    components:{DlgMessage},
    computed: {
      show: {
        get () {
          return this.visible
        },
        set (value) {
          if (!value) {
            this.$emit('close')
          }
        }
      }
    },    
  data() {
    return {
      message: "",
      customer_id:0,
      form:{login_id:"",customer_id:0,pin:""},
      rules: {
            required: value => !!value || 'Required.',
            counter: value => value.length == 6 || 'Need 6 digit',
            digit: value=> /[0-9][0-9][0-9][0-9][0-9][0-9]/.test(value) || 'Number only',
      },
    };
  },
  methods: {
    showDlg(customer_id){
        this.visible = true;
        this.form.customer_id = customer_id;
        //console.log(customer_id);
    },
    async save(){
        if(this.$refs.mainForm.validate()) {
            let title = 'Change PIN';
            try{
                ApCustomerService.change_pin(this.form).then(() => {
                    this.$refs.dlgMsg.showDlgBox(true,'success',title,'Success');
                }).catch((e)=>{
                        //console.log(e.response);
                    if(e.response.data.error_message)
                        this.$refs.dlgMsg.showDlgBox(true,'error',title,e.response.data.error_message);
                })
                    ;
            } catch(e) {
                if(e)
                    this.$refs.dlgMsg.showDlgBox(true,'error','title','Unknown Error');
            } 

        }

    }

  }
};

</script>
